import { render, staticRenderFns } from "./AddEditPublisherDialog.vue?vue&type=template&id=1f7065ce&scoped=true"
import script from "./AddEditPublisherDialog.vue?vue&type=script&lang=js"
export * from "./AddEditPublisherDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7065ce",
  null
  
)

export default component.exports